import React from 'react';
import { useFetchNoUser } from '../hooks/useFetchNoUser';
import {
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material/';

export default function SelectNationality({ nation, setNation, disabled }) {
  const { error, isPending, data } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/shared/country',
  );
  return (
    <FormControl fullWidth>
      <InputLabel id="selectNationality">Select Nationality*</InputLabel>

      <Select
        labelId="nationality"
        id="nationality"
        onChange={(e) => setNation(e.target.value)}
        input={<OutlinedInput label="selectNationality" />}
        required
        value={nation}
        disabled={disabled}
      >
        {data &&
          data.map((data) => (
            <MenuItem key={data.id} value={data.nationality}>
              {data.nationality}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
